import { TeamGanttImportError } from './teamGanttImportError';

/** RFC 4180-style CSV parser. Only a double quote at field start opens a quoted field. */
export function parseCSV(csvContent: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let quoted = false;
  let afterClosingQuote = false;
  let atFieldStart = true;

  const finishField = () => { row.push(field); field = ''; afterClosingQuote = false; atFieldStart = true; };
  const finishRow = () => { finishField(); if (row.some((value) => value !== '')) rows.push(row); row = []; };

  for (let index = 0; index < csvContent.length; index += 1) {
    const character = csvContent[index];
    if (quoted) {
      if (character === '"' && csvContent[index + 1] === '"') { field += '"'; index += 1; }
      else if (character === '"') { quoted = false; afterClosingQuote = true; }
      else field += character;
      continue;
    }
    if (afterClosingQuote && character !== ',' && character !== '\n' && character !== '\r') {
      throw new TeamGanttImportError('CSV contains an invalid character after a closing quote at position {{position}}', { position: index });
    }
    if (character === '"' && atFieldStart) { quoted = true; continue; }
    if (character === ',') { finishField(); continue; }
    if (character === '\n') { finishRow(); continue; }
    if (character === '\r') { if (csvContent[index + 1] === '\n') index += 1; finishRow(); continue; }
    field += character;
    atFieldStart = false;
  }
  if (quoted) throw new TeamGanttImportError('CSV contains an unterminated quoted field');
  if (field !== '' || row.length > 0) finishRow();
  return rows;
}
